import {
  UPDATE_TRAP_SITE_SETTINGS,
  UPDATE_TRAY_SETTINGS,
  UPDATE_COLLECTION_METHOD_SETTINGS,
  UPDATE_USER_SETTINGS,
  UPDATE_DEVICE_SETTINGS
} from "./types";

export const updateDataTableSettings =
  (tableName, settings) => async (dispatch) => {
    switch (tableName) {
      case "Collection Site":
        dispatch({ type: UPDATE_TRAP_SITE_SETTINGS, payload: settings });
        break;
      case "Collection Method":
        dispatch({ type: UPDATE_COLLECTION_METHOD_SETTINGS, payload: settings });
        break;
      case "Tray":
        dispatch({ type: UPDATE_TRAY_SETTINGS, payload: settings });
        break;
      case "Users":
        dispatch({ type: UPDATE_USER_SETTINGS, payload: settings });
        break;
      case "Devices":
        dispatch({ type: UPDATE_DEVICE_SETTINGS, payload: settings });
        break;
      default:
        return;
    }
  };
